module.exports = __webpack_public_path__ + "static/media/Credits-27.d73fb9b5.pdf";